import React from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";
const faqData = [
    {
        question:
            "What do DevOps and cloud solutions actually include?",
        answer:
            "They typically include managing cloud infrastructure, setting up deployment pipelines, automating releases, and improving how systems are monitored and maintained.",
    },
    {
        question:
            "Can you help improve our current deployment process?",
        answer:
            "Yes. We can review how deployments are currently handled and make them more predictable, faster and easier to manage through better pipeline setups.",
    },
    {
        question:
            "How do you ensure system stability and uptime?",
        answer:
            "We focus on monitoring, structured deployment practices, and infrastructure optimization to reduce disruptions and improve reliability.",
    },
    {
        question:
            "Can you help with scaling infrastructure as our usage grows?",
        answer:
            "Yes. We design cloud environments to handle increased load, additional services, and changing usage patterns without affecting performance.",
    },
    {
        question:
            "Do you provide ongoing support after setup?",
        answer:
            "Yes. Support can include monitoring, updates, performance improvements, and ongoing infrastructure management.",
    },
];

export default function FAQ() {
    return (
        <section className='padding-section-large faq-section'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Frequently Asked <span className="text-gradient-1">Questions</span></h2>
                    </Col>
                </Row>
                <Accordion defaultActiveKey="0" flush>
                    {faqData.map((faq, index) => (
                        <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="faq-item"
                        >
                            <Accordion.Header>
                                {faq.question}
                            </Accordion.Header>
                            <Accordion.Body>
                                {faq.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
        </section>
    );
}